module.exports = __webpack_public_path__ + "static/media/illusions-potion.edd8ac1a.png";